module.exports = __webpack_public_path__ + "img/emptyChat.e7fcd3e4.svg";